import { createTRPCContext } from '@trpc/tanstack-react-query'

// biome-ignore lint/style/useImportType: keep top-level `import type` (not inline) so Vite fully elides it and does not bundle the api router runtime into the client
import type { AppRouter } from '@langmail/api/trpc'

export const { TRPCProvider, useTRPC, useTRPCClient } = createTRPCContext<AppRouter>()
